var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTip(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.05556 2C9.81667 2 11 3.67625 11 5.24C11 8.40688 6.08889 11 6 11C5.91111 11 1 8.40688 1 5.24C1 3.67625 2.18333 2 3.94444 2C4.95556 2 5.61667 2.51188 6 2.96188C6.38333 2.51188 7.04444 2 8.05556 2Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00025 4.42578V4.84036M6.00025 4.84036H5.61638C5.19236 4.84036 4.84863 5.21159 4.84863 5.66953C4.84863 6.12747 5.19236 6.4987 5.61638 6.4987L6.38413 6.4987C6.80814 6.4987 7.15187 6.86993 7.15187 7.32786C7.15187 7.7858 6.80814 8.15703 6.38413 8.15703H6.00025M6.00025 4.84036H6.40831C6.6722 4.84036 6.90498 4.98415 7.04318 5.20312M6.00025 8.15703V8.57161M6.00025 8.15703H5.59219C5.32831 8.15703 5.09552 8.01325 4.95733 7.79427",
    stroke: "#0266FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTip);
export default __webpack_public_path__ + "static/media/tip.11b36b838eaaa53ce2f95d071cc6c0ef.svg";
export { ForwardRef as ReactComponent };